<grt-node-properties-editor [nodeName]="nodeName" [nodes]="nodes" (add)="add.next($event)" (nodesChanges)="update($event)"></grt-node-properties-editor>
